import api from '../api';

const routes = require('routes.js.erb');

// this should commit to store and update the item, but we're not at that point yet, still work to do so viewer is 100% async.

const updateItem = async function({ commit }, params) {
  const { itemId, body } = params;
  return api.patch(routes.api_v5_item_path(itemId), body).then(function(response){
    commit('setItem', response.data.data.item);
  })
}

const getItem = async function({ commit }, itemId) {
  return api.get(routes.api_v5_item_path(itemId)).then(function(response){
    commit('setItem', response.data.data.item);
  })
}

export { updateItem, getItem };
